import * as Yup from 'yup';
import { CommonMessages } from '../messages/validationMessages';
import { isValidPostalCode } from '../utils/countryState';

export const requiredPostalCode = (countryField = 'country') =>
    Yup.string()
        .required(CommonMessages.zipcode_required)
        .test('postal-code', CommonMessages.zipcode_mismatch, function (value) {
            if (!value) {
                return true;
            }
            return isValidPostalCode(value, this.parent[countryField]);
        });
